import { darken } from '@mui/material/styles';
import { makeStyles } from 'tss-react/mui';

const CONTROL_HEIGHT = 28;

interface AddProductToggleButtonStylesParams {
  isOpen: boolean;
}

export const useAddProductToggleButtonStyles = makeStyles<AddProductToggleButtonStylesParams>()(
  (theme, { isOpen }) => {
    const groupBorderColor = theme.palette.custom.border.primary;
    const groupHoverBorderColor = theme.palette.custom.border.secondary;

    return {
      toggleGroup: {
        alignItems: 'stretch',
        boxSizing: 'border-box',
        height: CONTROL_HEIGHT,
        border: `1px solid ${groupBorderColor}`,
        borderRadius: theme.shape.borderRadiusFull,
        overflow: 'hidden',
        backgroundColor: isOpen ? theme.palette.secondary.dark : 'transparent',
        '&:hover': {
          backgroundColor: isOpen
            ? darken(theme.palette.secondary.dark, 0.05)
            : theme.palette.secondary.light,
          borderColor: groupHoverBorderColor,
          '& .MuiDivider-root': { borderColor: groupHoverBorderColor },
        },
        '&:active': {
          backgroundColor: isOpen
            ? darken(theme.palette.secondary.dark, 0.1)
            : theme.palette.secondary.dark,
        },
        '& .MuiDivider-root': { borderColor: groupBorderColor },
        '& .MuiButton-root, & .MuiIconButton-root': {
          height: 'auto',
          background: 'transparent',
          '&:hover': { background: 'transparent' },
          '&[data-active="true"]': { background: 'transparent' },
        },
      },
    };
  },
);
